<template>
  <qx-card title="加气消费明细表">
    <section slot="titleLeft">
        <span style="margin-left: 10px!important;color:orange">油统计：</span>
        【加油量：
        <span class="primary">{{ oiltotalData.quantityToatl}} L</span>
        】 【加油金额：
        <span class="primary">{{ oiltotalData.amountToatl }} 元</span>
        】 【加油实付金额：
        <span class="primary">{{ oiltotalData.payAmountToatl }} 元</span>
        】
        <span style="margin-left: 50px!important;color:orange">气统计：</span>
        【加气量：
        <span class="primary">{{ gastotalData.quantityToatl }} KG</span>
        】 【加气金额：
        <span class="primary">{{ gastotalData.amountToatl}} 元</span>
        】 【加气实付金额：
        <span class="primary">{{ gastotalData.payAmountToatl}} 元</span>
        】
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="vehicleDataInfoBO.ajax?cmd=doQueryVehicleRefuelRecordExp"
            :params="fullSearchData"
            bizName="加气消费明细表导出"
            bizCode="exp202201"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
<!--    <QrcodeDialog ref="qrcodeDialog" />-->
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
              type="index"
              width="50">
          </el-table-column>
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'unit'">
                  <span v-if="scope.row.unit === 2">加气</span>
                  <span v-else-if="scope.row.unit === 1">加油</span>
                  <span v-else>--</span>
                </section>
                <section v-else-if="scope.column.property === 'fuelProductName'">
                  <span v-if="scope.row.unit === 1">{{ scope.row[scope.column.property] }}</span>
                  <span v-else></span>
                </section>
                <section v-else-if="scope.column.property === 'quantity'">
                  <span v-if="scope.row.unit === 2">{{ scope.row[scope.column.property] +'KG' }}</span>
                  <span v-else-if="scope.row.unit === 1">{{ scope.row[scope.column.property] +'L' }}</span>
                  <span v-else>--</span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  consumeDetailsList, // 消费明细列表
  gasConsumeTotal, // 数值总览
} from 'api/service';
import ExportBtn from 'components/exportBtn';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableSetting,
  },
  data () {
    return {
      oiltotalData: {
        quantityToatl: 0, // 加油量
        amountToatl: 0, // 加油金额
        payAmountToatl: 0, // 加油实付金额
      },
      gastotalData: {
        quantityToatl: 0, // 加气量
        amountToatl: 0, // 加气额
        payAmountToatl: 0, // 加气实付金额
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号'},
          { prop: 'labelCode', label: 'RFID电子标签序列号'},
          { prop: 'unit', label: '消费类型' },
          { prop: 'storeName', label: '油/气站名称' },
          { prop: 'scanTime', label: '加油/气时间' },
          { prop: 'fuelGunName', label: '油枪' },
          { prop: 'fuelProductName', label: '油号' },
          { prop: 'quantity', label: '加油/气量' },
          { prop: 'amount', label: '加油/气金额' },
          { prop: 'payAmount', label: '实付金额' },
          { prop: 'discountAmount', label: '优惠金额' },
          { prop: 'payTime', label: '数据请求时间' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: consumeDetailsList,
    async getOtherMsg (params) {
      const res = await gasConsumeTotal(params);
      if (!res.failed) {
        for (let i = 0; i < res.items.length; i++) {
          if (res.items[i].unit === 1) {
            this.oiltotalData = res.items[i] || {
              quantityToatl: 0, // 加油量
              amountToatl: 0, // 加油金额
              payAmountToatl: 0, // 加油实付金额
            };
          } else {
            this.gastotalData = res.items[i] || {
              quantityToatl: 0, // 加气量
              amountToatl: 0, // 加气额
              payAmountToatl: 0, // 加气实付金额
            };
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
